import { Button } from '@/components/ui/button';
import { formatRelativeTime } from '@/shared/utils/time';

/**
 * The line above a restored form: what is being continued, since when, and
 * the one way to say "no, start over" (spec 123 FR-013, spec 124 FR-010).
 * Shared so every form that keeps a draft says it the same way.
 */
export function DraftNote({
  noun,
  startedAt,
  extra,
  onDiscard,
}: {
  /** "connection", "trigger" — what the form makes. */
  noun: string;
  startedAt: string;
  /** A clause after the time, such as what was not kept. */
  extra?: string;
  onDiscard: () => void;
}) {
  return (
    <p
      role="status"
      className="text-muted-foreground flex flex-wrap items-center gap-x-2 text-xs"
    >
      <span>
        Continuing the {noun} you started {formatRelativeTime(startedAt)}
        {extra ?? ''}.
      </span>
      <Button
        type="button"
        variant="link"
        size="sm"
        className="h-auto px-0"
        onClick={onDiscard}
      >
        Discard
      </Button>
    </p>
  );
}
